var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52206 1.90886H10.5664C10.7532 1.90886 10.9324 1.83464 11.0645 1.70254C11.1966 1.57043 11.2708 1.39126 11.2708 1.20443C11.2708 1.0176 11.1966 0.838429 11.0645 0.706323C10.9324 0.574217 10.7532 0.5 10.5664 0.5H3.52206C3.33523 0.5 3.15606 0.574217 3.02395 0.706323C2.89184 0.838429 2.81763 1.0176 2.81763 1.20443C2.81763 1.39126 2.89184 1.57043 3.02395 1.70254C3.15606 1.83464 3.33523 1.90886 3.52206 1.90886ZM10.5664 4.02215H3.52206C3.33523 4.02215 3.15606 4.09637 3.02395 4.22847C2.89184 4.36058 2.81763 4.53976 2.81763 4.72658C2.81763 4.91341 2.89184 5.09258 3.02395 5.22469C3.15606 5.3568 3.33523 5.43101 3.52206 5.43101H10.5664C10.7532 5.43101 10.9324 5.3568 11.0645 5.22469C11.1966 5.09258 11.2708 4.91341 11.2708 4.72658C11.2708 4.53976 11.1966 4.36058 11.0645 4.22847C10.9324 4.09637 10.7532 4.02215 10.5664 4.02215ZM10.5664 7.5443H3.52206C3.33523 7.5443 3.15606 7.61852 3.02395 7.75063C2.89184 7.88273 2.81763 8.06191 2.81763 8.24873C2.81763 8.43556 2.89184 8.61474 3.02395 8.74684C3.15606 8.87895 3.33523 8.95316 3.52206 8.95316H10.5664C10.7532 8.95316 10.9324 8.87895 11.0645 8.74684C11.1966 8.61474 11.2708 8.43556 11.2708 8.24873C11.2708 8.06191 11.1966 7.88273 11.0645 7.75063C10.9324 7.61852 10.7532 7.5443 10.5664 7.5443Z",
    fill: "#FB7C51"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.70443,
    cy: 1.20443,
    r: 0.70443,
    fill: "#FB7C51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.70443,
    cy: 4.72787,
    r: 0.70443,
    fill: "#FB7C51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.70443,
    cy: 8.2474,
    r: 0.70443,
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.c83a8986c00f636199233f107a62baee.svg";
export { ForwardRef as ReactComponent };